import { useTranslations } from 'next-intl';

export function HomeOwnerHeader(props) {
  const { title, desc } = props;
  const t = useTranslations();
  return (
    <div className="flex flex-col gap-2.5">
      <h2 className="text-white text-2xl sm:text-[40px] sm:leading-[normal] font-semibold">
        {title ? title : t('form.home-owner.title')}
      </h2>
      <p className="text-slate-50 text-lg leading-7 max-w-[510px]">
        {desc ? desc : t('form.home-owner.description')}
      </p>
    </div>
  );
}
